import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss']
})
export class SectionTitleComponent implements OnInit {
  @Input() itemTitle: string;
  @Input() itemSubtitle: string;

  constructor() { }

  ngOnInit(): void {
  }

}
